<template>
    <page>
        <module enable-flex>
            <div class="account flex">
                <div class="item flex-grow item-blue">
                    <div class="info">
                        <div class="title-row flex-start-center">
                            <span class="title">同售账户(可提现金额)：</span>
                            <span class="amount">￥{{ account.withdrawable_cash_balance || 0 }}</span>
                        </div>
                        <div class="summary-row flex-start-center">
                            <span><label>余额：</label>￥{{ account.cash_balance || 0 }}</span>
                            <ins>|</ins>
                            <span><label>预计结算：</label>￥{{ account.wait_settle_cash_balance || 0 }}</span>
                            <ins>|</ins>
                            <span><label>冻结：</label>￥{{ account.frozen_cash_balance || 0 }}</span>
                        </div>
                    </div>
                    <div class="actions">
                        <div class="btn-group">
                            <button class="btn btn-orange"
                                    v-if="auth('b_balance_account_withdraw')"
                                    @click="cashWithdrawApply"
                                    :disabled="account.withdrawable_cash_balance <= 0">提现
                            </button>
                            <button class="btn btn-white"
                                    v-if="auth('b_balance_account_withdraw')"
                                    @click="globalDialog('withdrawApplyList', {props: {withdraw_account_type:2,withdraw_user_type:1}})">
                                提现记录
                            </button>
                        </div>
                    </div>
                </div>
                <div class="item flex-grow item-orange">
                    <div class="info">
                        <div class="title-row flex-start-center">
                            <span class="title">通联账户(可提现金额)：</span>
                            <span class="amount">￥{{ account.withdrawable_balance || 0 }}</span>
                        </div>
                        <div class="summary-row flex-start-center">
                            <span><label>余额：</label>￥{{ account.balance || 0 }}</span>
                            <ins>|</ins>
                            <span><label>预计结算：</label>￥{{ account.wait_settle_balance || 0 }}</span>
                            <ins>|</ins>
                            <span><label>冻结：</label>￥{{ account.frozen_balance || 0 }}</span>
                        </div>
                    </div>
                    <div class="actions">
                        <div class="btn-group">
                            <button class="btn btn-white"
                                    v-if="auth('b_balance_account_withdraw')"
                                    @click="checkDepositBefore(() => globalDialog('accountWithdraw', {props: {withdraw_account_type:1}},handle))"
                                    :disabled="account.withdrawable_balance <= 0"
                                    style="color: #ff8c00">提现
                            </button>
                            <button class="btn btn-white"
                                    v-if="auth('b_balance_account_withdraw')"
                                    @click="globalDialog('withdrawApplyList', {props: {withdraw_account_type:1,withdraw_user_type:1}})">
                                提现记录
                            </button>
                        </div>
                        <span class="recharge"
                                v-if="auth('b_balance_account_recharge')"
                                @click="globalDialog('accountRecharge', {props: {}},handle)">充值</span>
                    </div>
                </div>
            </div>
            <view-list ref="view" class="flex-grow" :work-type="workType" :view-config="saasInfo.viewmanage">
                <template #search>
                    <m-search ref="search" :extend-data="defaultSearchData">
                        <m-search-item label="记录单号">
                            <c-input name="record_number"></c-input>
                        </m-search-item>
                        <m-search-item label="收支类型">
                            <c-select :options="INCOME_EXPENSES" name="income_expenses"></c-select>
                        </m-search-item>
                        <m-search-item label="账单类型">
                            <c-input name="trans_type"></c-input>
                        </m-search-item>
                        <m-search-item label="业务单号">
                            <c-input name="docket_number"></c-input>
                        </m-search-item>
                        <m-search-item label="备注">
                            <c-input name="remark"></c-input>
                        </m-search-item>
                        <m-search-item label="创建时间">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button v-if="auth('b_balance_account_record_export')"
                                prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出
                    </c-button>
                </template>

                <!--账户类型-->
                <template #account_type="{data}">
                    <c-state  async dict="ACCOUNT_TYPE" :value="data.account_type"></c-state>
                </template>
                <!--收支类型-->
                <template #income_expenses="{data}">
                    <c-state  async dict="INCOME_EXPENSES" :value="data.income_expenses"></c-state>
                </template>
                <!--收支状态-->
                <template #trans_state="{data}">
                    <c-state  async dict="TRANS_STATE" :value="data.trans_state"></c-state>
                </template>
                <!--资金-->
                <template #money="{data}">
                    <span v-if="data.income_expenses == 1" style="color: green">￥+{{data.money}}</span>
                    <span v-if="data.income_expenses == 2" style="color: red">￥{{data.money}}</span>
                </template>
                <!--余额-->
                <template #surplus_money="{data}">
                    <span v-if="data.surplus_money">
                        ￥{{data.surplus_money}}
                    </span>
                    <span v-else>-</span>
                </template>
            </view-list>
        </module>
    </page>
</template>

<script>
import saasDeposit from '@/mixins/saas_deposit';
import {mapState} from "vuex";
import {asyncMapState} from '@/store'

export default {
    mixins: [saasDeposit],
    name: 'm_balance_account_record',
    data() {
        return {
            workType: 104,
            defaultSearchData: {
                user_type: 1     //默认查询主账号数据
            },
            account: {}
        }
    },
    computed: {
        // 获取dictName选项数据
        ...mapState(['saasInfo']),
        ...asyncMapState(['INCOME_EXPENSES'])
    },

    mounted() {
        this.loadAccount();
    },

    methods: {
        /**
         * 加载账户余额信息
         */
        loadAccount() {
            this.request({
                url: '/sys_saas/account/info',
                data: {},
                loading: false,  // 是否显示loading，
                success: data => {
                    this.account = data;
                }
            });
        },
        //打开提现页面
        cashWithdrawApply(){
            this.checkDepositBefore(() => {
                this.globalDialog('cashWithdrawApply',
                        {
                            props:
                                    {withdraw_account_type:2}
                        },
                this.loadAccount());
            });
        },

        /*********充值或提现申请完成后回调****************/
        handle() {
            //延迟0.8秒执行回调
            setTimeout(() => {
                //1、重新加载余额
                this.loadAccount();
                //2、加载数据列表
                this.$refs.view.update();
            }, 200);
        }
    }
}
</script>

<style lang="stylus" scoped>
.account {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    padding: 12px 16px 2px;

    .item {
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        max-width: 550px;
        padding: 12px 20px 14px;
        border-radius: 8px;
        color: #fff;

        &.item-blue {
            background: linear-gradient(90deg, #2563eb, #3b82f6);
        }

        &.item-orange {
            background: linear-gradient(90deg, #f97316, #fb923c);
        }

        .info {
            .title-row {
                display: flex;
                line-height: 32px;

                .title {
                    font-size: 13px;
                    opacity: 0.95;
                }

                .amount {
                    font-size: 24px;
                    font-weight: bold;
                }
            }

            .summary-row {
                gap: .5em;
                margin-top: 4px;
                font-size: 12px;
                opacity: 0.8;
            }
        }

        .actions {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            gap: 10px;

            .btn-group {
                display: flex;
                gap: 10px;
            }

            .btn {
                padding: 6px 18px;
                border: none;
                border-radius: 16px;
                font-size: 13px;
                cursor: pointer;
                transition: opacity 0.2s;

                &:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                }

                &.btn-orange {
                    background: #ff8c00;
                    color: #fff;

                    &:not(:disabled):hover {
                        background: #ffa033;
                    }
                }

                &.btn-white {
                    background: #fff;
                    color: #333;

                    &:not(:disabled):hover {
                        background: #f0f0f0;
                    }
                }
            }

            .recharge {
                margin-right: 12px;
                font-size: 13px;
                color: #fff;
                opacity: 0.9;
                cursor: pointer;

                &:hover {
                    opacity: 1;
                }
            }
        }
    }
}
</style>